import { IndicatorsContainerProps } from 'react-select'
import { LuChevronDown, LuChevronUp } from 'react-icons/lu'

import { SelectOption } from '@/lib/core/components/Select'
import { Colors } from '@/lib/core/components/Select/Select.styles'
import { IndicatorWrapper } from '@/lib/core/components/Select/components/IndicatorsContainer.styles'

export const IndicatorsContainer = ({
  selectProps,
  theme,
}: IndicatorsContainerProps<SelectOption>) => (
  <IndicatorWrapper color={(theme.colors as Colors).primary}>
    {selectProps.menuIsOpen ? (
      <LuChevronUp size="24" strokeWidth={1.5} />
    ) : (
      <LuChevronDown size="24" strokeWidth={1.5} />
    )}
  </IndicatorWrapper>
)
